



































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { mapGetters, mapState, mapActions } from 'vuex';
import ReservationQuoteDetailsPopover from '@/components/ReservationQuoteDetailsPopover.vue';
import ReservationQuoteDetailsList from '@/components/ReservationQuoteDetailsList.vue';
import ReservationLocation from '@/components/ReservationLocation.vue';
import Quote from '@/models/Quote';
import Reservation from '@/models/Reservation';
import moment from 'moment';

const Setup = Vue.extend({
	name: 'ReservationQuote',
	components: { ReservationQuoteDetailsPopover, ReservationQuoteDetailsList, ReservationLocation },
	props: {
		quote: { type: Object, required: true },
		selectable: Boolean,
	},
	computed: {
		...mapGetters(['isLoggedIn']),
		...mapState('reservation', ['reservation']),
		...mapGetters('location', ['settings']),
	},
	methods: {
		...mapActions('location', ['setLocation']),
	},
});

@Component
class ReservationQuote extends Setup {
	// Props
	public quote!: Quote;
	public selectable!: boolean;

	// Vuex
	public isLoggedIn!: boolean;
	public reservation!: Reservation;
	public settings!: Locations.Settings;
	public location!: Locations.Location;
	public setLocation!: (locationCode: string) => Promise<any>;

	public onSelect() {
		this.$store.dispatch('googleEvents/userSelectedQuote', {
			theQuote: this.quote,
		});
		// let location_map = NP_PLUGIN_DATA.locationsMap;
		// if(this.quote.location_information) {
		// 	const current_location = location_map[this.quote.location_information.location].codeID;
		// 	this.setLocation(current_location);
		// }

		return this.$emit('selected', this.quote);
	}

	public get prepay(): number {
		if (this.reservation.auto_key) {
			return this.quote.prepaid;
		}

		return this.quote.prepay_amount;
	}

	public get descriptionLength(): number {
		return this.settings.quote_desc_length > 0
			? +this.settings.quote_desc_length
			: 100;
	}

	public get dueAtLot(): number {
		if (this.reservation.auto_key) {
			return this.quote.balance_due;
		}

		return this.quote.due_at_lot;
	}

	public get dueText(): string {
		if (this.reservation.auto_key && this.reservation.prepaid && this.settings.adjustable_prepay) {
			if (this.quote.balance_due > 0) {
				return 'To be Charged';
			}

			if (this.quote.balance_due < 0) {
				return 'To be Refunded';
			}
		}

		return 'Due at Lot';
	}

	public get title(): string {
		if (!this.quote.is_event) {
			return this.quote.name;
		}

		return this.quote.name.substring(0, this.quote.name.indexOf(':'));
	}

	public get total(): number {
		return !this.settings.show_parking_net ? this.quote.grand_total : (this.quote.parking_rate_subtotal - +this.quote.savings);
	}

	public get subtitle(): string {
		if (!this.quote.is_event) {
			return '';
		}

		return this.quote.name.substring(this.quote.name.indexOf(':') + 1).trim();
	}

	public get eventText(): string {
		let format = 'MM/DD h:mma';
		if (!this.settings.hide_event_time_details_on_quote && this.settings.hide_event_date_details_on_quote) {
			format = 'h:mma';
		}
		if (this.settings.hide_event_time_details_on_quote && !this.settings.hide_event_date_details_on_quote) {
			format = 'MM/DD';
		}

		return `Valid ${moment(this.quote.event_dates[0]).format(format)} to ${moment(this.quote.event_dates[1]).format(format)}`;
	}
}

export default ReservationQuote;
